import { QuestionAnswerInterface } from './../../util/interfaces/customSatisfaction';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { RequestSatisfactionService } from './service/request-satisfaction.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { CustomSatisfactionInterface } from 'src/app/util/interfaces/customSatisfaction';
import { CustomSatisfactionRequestService } from 'src/app/page/register-page/register-forms/request/custom-satisfaction-request/service/custom-satisfaction-request.service';
import { forkJoin } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { MysupportEvaluationModule } from '../mysupport-evaluation/mysupport-evaluation.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';

@Component({
	standalone: true,
	imports: [CommonModule, MysupportEvaluationModule, FontAwesomeModule, SvgGearsModule, DotBounceLoadingEffectModule],
	selector: 'pcp-request-satisfaction',
	templateUrl: './request-satisfaction.component.html',
	styleUrls: ['./request-satisfaction.component.scss'],
})
export class RequestSatisfactionComponent implements OnInit, OnChanges {
	@Input()
	requestId: string;

	@Input()
	listName: string;

	@Output()
	leavePage = new EventEmitter();

	faIcon = {
		faXmark: faXmark,
	};

	selectedComment: { [key: string]: string } = {};
	selectedOption: { [key: string]: string } = {};
	selectQuestion: { [key: string]: string } = {};

	isThisRequestFinished: boolean = null;
	showDiv: boolean = null;
	satisfactionLevel: string = null;
	requestIdParam = '';
	commentary = '';
	hideRequestSatisfaction = false;
	evaluatingYourself: boolean;
	customList: CustomSatisfactionInterface[] = [];

	isLoadingSubmit = false;
	isLoadingLabels = true;
	isLoadingRequestSatisfaction = true;
	isLoadingEvaluatingYourself = true;
	isLoadingCustom = false;
	isOpenModalEvaluationMSP = false;

	routeParam = true;

	labels: LabelsInterface = {
		lbl_chamado_avaliacao_atendimento: 'Request Evaluation',
		lbl_chamado_vc_considera: 'Do you consider this request solved',
		lbl_geral_nao: 'No',
		lbl_geral_sim: 'Yes',
		lbl_chamado_qual_grau_satisfacao: 'What is your satisfaction level',
		lbl_geral_insatisfeito: 'Unsatisfied',
		lbl_geral_satisfeito: 'Satisfied',
		lbl_geral_muito_satisfeito: 'Very satisfied',
		lbl_leave_a_comment: 'Leave a comment',
		lbl_geral_enviar: 'Submit',
		lbl_request_successful_evaluated: 'Request successful evaluated!',
		lbl_geral_inicio: 'Start',
		lbl_geral_chamado: 'Requests',
		lbl_geral_avaliacao: 'Assessement',
		lbl_edocs_carregando: 'Loading',
		lbl_preencha_todos_asteriscos: '',
		lbl_clique_aqui_para_chamado: '',
		lbl_geral_avaliacao_importante: 'Your rating is very important to the process of continuous improvement of our services.',
		lbl_geral_obrigado_avaliacao: 'Thank you for your evaluation',
		lbl_campo_desativado_para_este_cliente: 'Field disabled for this client',
		lbl_nao_pode_avaliar_chamado_que_atendeu: 'You cannot evaluate a ticket that you attended yourself',
		lbl_geral_avaliar: 'Evaluate',
		lbl_comentario: 'Comment',
		lbl_comentario_opcional: 'Comment (Optional)',
	};

	constructor(
		private requestSatisfactionService: RequestSatisfactionService,
		private labelsService: LabelsService,
		private NotificationService: NotificationService,
		private Router: Router,
		private ActivatedRoute: ActivatedRoute,
		private PermissionService: PermissionService,
		private customSatisfactionRequestService: CustomSatisfactionRequestService
	) {}

	ngOnInit(): void {
		this.PermissionService.getCustomersPermissions().subscribe((parameters) => {
			if (this.PermissionService.hasPermission('hide_request_satisfaction')) {
				this.hideRequestSatisfaction = true;
			}
			this.isLoadingRequestSatisfaction = false;
		});

		this.PermissionService.getCustomersPermissions().subscribe((parameters) => {
			if (this.PermissionService.hasPermission('avaliacao_atendimento_personalizada')) {
				this.isLoadingCustom = true;
				this.getAllCustomSatisfaction();
			} else {
				this.isLoadingCustom = false;
			}
		});

		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			if (parameters.satisfaction_level) {
				this.requestIdParam = this.ActivatedRoute.snapshot.paramMap.get('requestId');
				this.requestSatisfactionService
					.updateEvaluateRequest(this.requestIdParam, parameters.satisfaction_level)
					.subscribe(() => {});
			} else {
				this.routeParam = false;
			}
		});

		this.requestSatisfactionService.getSatisfactionPin(this.requestId).subscribe((requestInfo: any) => {
			requestInfo = requestInfo[0];
			if (
				requestInfo.email_enduser == requestInfo.email_analyst ||
				requestInfo.satisfaction_pin == undefined ||
				requestInfo.satisfaction_pin == ''
			) {
				this.Router.navigateByUrl('/request/' + requestInfo.id);
				return;
			}
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.requestId.currentValue != changes.requestId.previousValue) {
			this.isThisRequestFinished = null;
			this.satisfactionLevel = null;
			this.commentary = '';
		}
	}

	submitSatisfaction() {
		if (this.isLoadingSubmit) return;

		if (this.hideRequestSatisfaction && this.satisfactionLevel == undefined) {
			this.satisfactionLevel = 'Satisfied';
		}

		if (this.hideRequestSatisfaction && this.commentary == '') {
			this.commentary = this.labels.lbl_campo_desativado_para_este_cliente;
		}

		if (this.satisfactionLevel && this.isThisRequestFinished != undefined && this.commentary.trim() != '') {
			this.isLoadingSubmit = true;

			this.PermissionService.getCustomersPermissions().subscribe((parameters) => {
				if (this.PermissionService.hasPermission('avaliacao_atendimento_personalizada')) {
					this.questionAnswer();
				}
			});

			this.requestSatisfactionService.getSatisfactionPin(this.requestId).subscribe((requestInfo: any) => {
				requestInfo = requestInfo[0];
				this.requestSatisfactionService
					.evaluateRequest(
						requestInfo.id,
						requestInfo.satisfaction_pin,
						this.isThisRequestFinished,
						this.satisfactionLevel,
						this.commentary
					)
					.subscribe((res) => {
						this.isLoadingSubmit = false;
						this.NotificationService.setNotificationMessage(this.labels.lbl_request_successful_evaluated);
						this.emitLeavePage();
					});
			});
		} else {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		}
	}

	emitLeavePage(): void {
		this.leavePage.emit(true);
	}

	goTo(to: string): void {
		this.Router.navigate([to]);
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal

	getAllCustomSatisfaction(): void {
		this.customSatisfactionRequestService.getAllCustomSatisfaction().subscribe((data: CustomSatisfactionInterface[]) => {
			this.customList = data;
		});
	}

	questionAnswer(): void {
		const forms: QuestionAnswerInterface[] = [];

		for (const item of this.customList) {
			const form: QuestionAnswerInterface = {
				answer: this.selectedOption[item.id] || '',
				comment: this.selectedComment[item.id] || '',
				question: item.question || '',
				request: this.requestId,
			};

			forms.push(form);
		}

		const observables = forms.map((form) => this.customSatisfactionRequestService.postQuestionAnswer(form));

		forkJoin(observables).subscribe(
			(responses) => {
				// Lógica após enviar todas as respostas
			},
			(error) => {
				// Lógica para lidar com erros
			}
		);
	}
}
